module.exports = __webpack_public_path__ + "img/food7.4ac00370.jpg";